import { React, useState } from 'react'
import { Field, ErrorMessage } from 'formik'
import { Box, Typography, RadioGroup } from '@mui/material'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxRadioButton from 'components/custom/AdxRadioButton'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxInput from 'components/custom/AdxInput'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'

const CreditExpiry = ({ formikBag }) => {
  const { values, handleChange, setFieldValue } = formikBag

  //For Custom Expiry Date
  const [creditExpiry, setCreditExpiry] = useState(
    values.credit_expiry_period === 'cycle_period'
      ? -1
      : values.credit_expiry_period === 'no_expiry'
      ? -2
      : 0
  )

  return (
    <Box>
      <Typography variant="subtitle1">Leave Credit Expiry Date</Typography>
      <RadioGroup
        name="creditExpiry"
        value={creditExpiry}
        onChange={(event) => {
          setCreditExpiry(Number(event.target.value))
          if (Number(event.target.value) === -1) {
            setFieldValue('credit_expiry_period', 'cycle_period')
          }
          if (Number(event.target.value) === -2) {
            setFieldValue('credit_expiry_period', 'no_expiry')
          }
          if (Number(event.target.value) === 0) {
            setFieldValue('credit_expiry_period', 'day')
          }
        }}
      >
        <AdxFormControlLabel
          type="no-fill"
          value={-1}
          control={<AdxRadioButton />}
          label="End Of Cycle Period"
        />
        <AdxFormControlLabel
          type="no-fill"
          value={-2}
          control={<AdxRadioButton />}
          label="No expiry"
        />
        <AdxFormControlLabel type="no-fill" value={0} control={<AdxRadioButton />} label="Custom" />

        {creditExpiry === 0 ? (
          <Box
            sx={{
              width: 1,
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: null, sm: 'center' },
              gap: 1,
            }}
          >
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Field
                as={AdxInput}
                name="credit_expiry_amount"
                value={values.credit_expiry_amount || ''}
                onChange={handleChange}
                type="number"
                sx={{ width: 1 / 2 }}
              />
              <Field
                as={AdxDropdown}
                name="credit_expiry_period"
                value={values?.credit_expiry_period || ''}
                onChange={handleChange}
                sx={{ width: 1 / 2 }}
              >
                <AdxMenuItem value="day" selectedvalue={values.credit_expiry_period}>
                  Days
                </AdxMenuItem>
                <AdxMenuItem value="week" selectedvalue={values.credit_expiry_period}>
                  Weeks
                </AdxMenuItem>
                <AdxMenuItem value="month" selectedvalue={values.credit_expiry_period}>
                  Months
                </AdxMenuItem>
              </Field>
            </Box>

            <Box sx={{ mx: { xs: null, sm: 1 } }}>
              <Typography variant="subtitle1">after credited date</Typography>
            </Box>
          </Box>
        ) : null}
      </RadioGroup>
      <Box sx={{ ml: { xs: 4, sm: null } }}>
        <ErrorMessage name="credit_expiry_amount" component={AdxErrorMessage} />
      </Box>
    </Box>
  )
}

export default CreditExpiry
